import mwcMarketsCore from 'mwc-markets-core';
import Component from './src/watchlist.vue';

const { createCustomElement } = mwcMarketsCore;

export default createCustomElement(Component);
